const PROD = 'http://ec2-18-190-25-27.us-east-2.compute.amazonaws.com:8080/API';
const DEV = `http://ec2-18-190-25-27.us-east-2.compute.amazonaws.com:8080/APIT`;
const LOCAL = 'http://localhost:3001/api';
export const API_URL = PROD;
export const API_REQUEST_STATUS_LOADING = 0;
export const API_REQUEST_STATUS_SUCCEEDED = 1;
export const API_REQUEST_STATUS_FAILED = 2;



// WEBPACK FOOTER //
// ./src/services/config.js